<template>
  <b-row>
    <b-col cols="12" v-if="data && data.length > 0">
      <b-row class="py-1" v-for="(individual, index) in data" :key="index">
        <b-col>
          <b-row class="py-1 border-b border-gray items-center">
            <b-col style="text-transform: uppercase">
              <span class="text-xs font-bold text-capitalize">
                {{ individual.givenName }} <span v-if="individual.middleNames">{{ individual.middleNames }}</span> {{ individual.surname }}
              </span>
            </b-col>
            <b-col class="text-xs">
              <b-badge class="bg-orange mr-2">#individual{{ data.length > 1 ? ' ' + (index + 1) : '' }}</b-badge>
              <b-badge v-if="individual.isUgandan" class="bg-green">Ugandan Citizen</b-badge>
            </b-col>
            <b-col>
              <button class="bg-blue text-white rounded-sm px-2 py-1 text-xs float-end" @click="show(index)">
                <span v-if="selectedIdx === index">Hide Details</span>
                <span v-else>Show Details</span>
              </button>
            </b-col>
          </b-row>
          <b-row v-if="showDetails && selectedIdx === index" class="mt-2">
            <b-col cols="12">
              <b-row>
                <b-col>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Given Name"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="individual.givenName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="individual.middleNames"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Middle Name"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="individual.middleNames"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Surname"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="individual.surname"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="individual.idType"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="ID Type"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="getIdTypeLabel(individual.idType).toLowerCase()"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="ID Number"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="individual.idNumber || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Email Address"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="individual.email || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Phone Number"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="individual.phone || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="individual.gender"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Gender (at birth)"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="individual.gender.toLowerCase()"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Date of Birth"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="formatDate(individual.dateOfBirth)"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col v-if="individual.address">
                  <AdminUnitsView :data="individual.address" :api="api" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" v-else>
      <div class="text-center py-8 text-gray-500 text-sm">
        <i class="fa fa-user-slash text-3xl mb-2"></i>
        <p>No individuals information available</p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import AdminUnitsView from './AdminUnitsView.vue';

export default {
  name: 'IndividualsView',
  components: { AdminUnitsView },
  props: {
    data: {
      type: Array,
      default: function () { return []; },
    },
    cardinality: {
      type: String,
      default: '',
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showDetails: false,
      selectedIdx: null
    };
  },
  methods: {
    show(idx) {
      if (this.selectedIdx === idx) {
        this.selectedIdx = null;
        this.showDetails = false;
      } else {
        this.selectedIdx = idx;
        this.showDetails = true;
      }
    },
    getIdTypeLabel(idType) {
      if (!idType) return '–';
      var labels = {
        national_id: 'National ID',
        passport: 'Passport',
        driving_permit: 'Driving Permit',
        refugee_id: 'Refugee ID',
        voter_id: 'Voter ID',
      };
      return labels[idType] || idType || '–';
    },
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format("DD/MM/YYYY");
      }
      return "–";
    },
  },
};
</script>

<style scoped>

</style>
